import axios from "axios";

// Set withCredentials on axios before creating instance (if we r working with cookies)
//  axios.defaults.withCredentials = true;

const baseURL = process.env.REACT_APP_API_BASE_URI

const apiAxiosInstance = axios.create({
    baseURL: `${baseURL}`,

    /* on timeout checks request on slow network if request takes too long on slow network then axios cancels it (handle such canceled requests). */
    timeout: 60000, /**1min */
    maxContentLength: 2000
});

/**------------------------------------------------------ */

// Add a request interceptor
/**
 * axios.interceptors.request.use(config_Callback, error)
 */

apiAxiosInstance.interceptors.request.use(

    (request) => {
        /*
          token from persisted store must be accessed here only. otherwise '401:unautherization' error will be produced by axios
        */
        const token = sessionStorage.getItem('AccessToken')

        // request.headers['TokenType'] = 'ADB2C';

        // console.log("token:", token);
        if (!!token) {
            request.headers.Authorization = `Bearer ${token}`
        }
        return request;
    },
    (error) => {

        console.log('apiAxiosInstanceRequestError:', error)

        // Do something with request error
        return Promise.reject(error);

    }
);

/**------------------------------------------------------ */


// Add a response interceptor
/**
 * axios.interceptors.response.use(response_Callback, error)
 */
apiAxiosInstance.interceptors.response.use(

    (response) => {
        // Do something after response is received

        // console.log("AXIOSRESP:..", response)

        return response;

    },
    (error) => {
        console.log('apiAxiosInstanceResponseError:', error)

        // Do something with request error
        return Promise.reject(error);

    }
);

export default apiAxiosInstance;
